import React, {useState} from 'react'
import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import Logo from '../assets/logo.png';
import 'animate.css';

const Header = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  // Function to handle navbar collapse on link click
  const handleLinkClick = () => {
    setIsCollapsed(true);
  };


  return (
    <>
      <section className='py-1'>
        <div className='container px-lg-5 px-4'>

          <div className='d-lg-flex d-md-flex d-sm-flex d-block justify-content-between'>

            <div className='my-lg-3 my-md-3 my-sm-3 my-2 text-center'>
              <Link className='text-muted text-decoration-none' to='mailto:travelsomanshi@gmail.com'><i className="fa-solid fa-envelope"></i> travelsomanshi@gmail.com</Link> |&nbsp;
              <Link className='text-muted text-decoration-none' to='tel:8726359735'><i className="fa-solid fa-phone"></i> 8726359735</Link> |&nbsp;
              <Link className='text-muted text-decoration-none' to='https://maps.app.goo.gl/7urrmdPYV3vSbnYY6' target='_blank'><i class="fa-solid fa-map-pin"></i> View Map</Link></div>

            <div className='my-lg-3 my-md-3 my-sm-3 my-2 text-center d-flex flex-wrap justify-content-center'>
              <Link className='header-icon' to='https://www.facebook.com/share/1BFYWv7sSn/' target='_blank'><i className="fa-brands px-3 fa-facebook-f"></i></Link>
              {/* <Link className='header-icon'><i className="fa-brands px-3 fa-x-twitter"></i></Link>
              <Link className='header-icon'><i className="fa-brands px-3 fa-linkedin-in"></i></Link> */}
              <Link className='header-icon' to='https://www.instagram.com/omanshitravels?utm_source=qr&igsh=MWozcmN4MXBkN3A1MA==' target='_blank'><i className="fa-brands px-3 fa-instagram"></i></Link>
              <p className='my-0 animate__animated animate__flash animate__slow animate__infinite px-3'>
                <Link className='nav-text text-danger' to='/'>माघ मेला 2026 <i class="fa-solid fa-sun fa-spin"></i></Link></p></div>
          </div>
          {/* flex ends */}


          <nav className="navbar navbar-expand-lg navbar-light bg-white">
            <div className="container-fluid">
              <Link className="navbar-brand py-0" to='/'><img src={Logo} className='img-fluid' alt='site logo' style={{height: '3.2em'}} /></Link>
              <button className="navbar-toggler" onClick={() => setIsCollapsed(!isCollapsed)} type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <i class="fa-solid fa-bars-progress"></i>
              </button>
              <div className={`collapse navbar-collapse ${isCollapsed ? '' : 'show'}`} id="navbarSupportedContent">
                <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                  <li className="nav-item my-2">
                    <NavLink className="nav-text" activeClassName="active" onClick={handleLinkClick} to="/">Home</NavLink>
                  </li>
                  <li className="nav-item my-2">
                    <NavLink className="nav-text" activeClassName="active" onClick={handleLinkClick} to="/about">About</NavLink>
                  </li>
                  <li className="nav-item my-2">
                    <NavLink className="nav-text" activeClassName="active" onClick={handleLinkClick} to="/destination-gallery">Destination Gallery</NavLink>
                  </li>
                  <li className="nav-item my-2">
                    <NavLink className="nav-text" activeClassName="active" onClick={handleLinkClick} to="/tour-booking">Tour Booking</NavLink>
                  </li>
                  <li className="nav-item my-2">
                    <NavLink className="nav-text" activeClassName="active" onClick={handleLinkClick} to="/contact">Contact</NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
          {/* navbar ends */}

        </div>
      </section>
    </>
  )
}

export default Header
